export let februaryUppercase = "GiZT7c";
export default {februaryUppercase};